if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');
            this.deliveryEstimate = this.querySelector('[js-estimated-delivery]');
			this.productVariants = this.querySelector('product-variants[data-main-product-variants]') || this.querySelector('subscription-selector[data-main-product-variants]');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');
			
			this.sellingPlanContainer = document.querySelector(`product-page[data-id="${this.dataset.id}"] .product-selling-plan__container`);
			if (this.sellingPlanContainer) {
				this.sellingPlanSelector = this.querySelectorAll('[data-js-variant-selling-plans]');
				this.sellingPlanGroup = this.querySelectorAll(`[data-js-product-selling-plan-group]`);
				this.subscribeIntent = this.querySelector('[data-js-subscribe-intent]');
				
				this._selling_plan_event = new Event('SELLING_PLAN_CHANGE');
				this._selling_plan_group_event = new Event('SELLING_PLAN_GROUP_CHANGE');
				this._subscribe_intent = new Event('SUBSCRIBE_INTENT');
			
				if (this.subscribeIntent) {
					this.subscribeIntent.addEventListener('click', () => {
						this.productVariants.dispatchEvent(this._subscribe_intent);
					});
				}

				if (this.sellingPlanSelector) {
					this.sellingPlanSelector.forEach(elm => {
	
						elm.addEventListener('change', () => {
	
							this.productVariants.dispatchEvent(this._selling_plan_event);
	
						});
					});
				}

				if (this.sellingPlanSelector) {
					this.sellingPlanGroup.forEach(elm => {
						elm.querySelector('input[name="selling-plan"]').addEventListener('change', () => {
							this.productVariants.dispatchEvent(this._selling_plan_group_event);
							this.productVariants.dispatchEvent(new Event("VARIANT_CHANGE"));
						});
					});
				}
			}
          
            // Gallery thumbnails
			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top + window.scrollY,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Product variant event listener for theme specific logic

			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});


				// refresh color
				this.querySelectorAll('.product-variant__item--radio').forEach(elm=>{
					elm.addEventListener('click', e=>{
						if ( elm.classList.contains('product-variant__item--color' ) ) {
							elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.querySelector('input').value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

			// update secondary price if present

			this.priceCompact = this.querySelector('[data-js-product-price-compact');
			this.priceExtended = this.querySelector('[data-js-product-price-extended');
			this.priceOneTime = this.querySelector('[data-js-product-price-one-time-price]');
			


			if(this.priceOneTime) {
				this.priceOneTime.priceOriginal = this.priceOneTime.querySelector('[data-js-product-price-original]');
				this.priceOneTime.priceCompare = this.priceOneTime.querySelector('[data-js-product-price-compare]');
			}

			if ( this.priceCompact ) {
				this.priceCompact.priceOriginal = this.priceCompact.querySelector('[data-js-product-price-original]');
				this.priceCompact.priceCompare = this.priceCompact.querySelector('[data-js-product-price-compare]');
				this.priceCompact.priceUnit = this.priceCompact.querySelector('[data-js-product-price-unit]');
				this.priceCompact.isSale = this.priceCompact.querySelector('.product-price--sale');
			}
			if ( this.priceExtended ) {
				this.priceExtended.priceOriginal = this.priceExtended.querySelector('[data-js-product-price-original]');
				this.priceExtended.priceCompare = this.priceExtended.querySelector('[data-js-product-price-compare]');
				this.priceExtended.priceSaving = this.priceExtended.querySelector('[data-js-product-price-saving]');
				this.priceExtended.priceUnit = this.priceExtended.querySelector('[data-js-product-price-unit]');
			}

            if (this.deliveryEstimate) {
              	this.deliveryEstimate.subscriptionMessage = this.deliveryEstimate.querySelector('[data-subscription-message]');
              	this.deliveryEstimate.subscriptionFrequency = this.deliveryEstimate.querySelector('[data-subscription-frequency]');
              	this.deliveryEstimate.firstDeliveryMessage = this.deliveryEstimate.querySelector('[data-first-delivery-message]');
              	this.deliveryEstimate.firstDeliveryDate = this.deliveryEstimate.querySelector('[data-first-delivery-date]');
            }

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
            let selling_plan = e.target.currentSellingPlan;
            let _selling_plan = e.target._currentSellingPlan;
            let selling_option = e.target.currentSellingPlanGroup;

			if ( variant ) {

              // Handle Estimated Delivery
                if(this.deliveryEstimate) {

                  var fromDate = Date.today().addDays(2);
                  if (fromDate.is().saturday() || fromDate.is().sunday()) {
                  fromDate = fromDate.next().monday();
                  }
                  
                  this.deliveryEstimate.firstDeliveryDate.innerHTML = ` <strong>${fromDate.toString('dddd MMMM dS')}</strong>`

                } 
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.getBoundingClientRect().top + window.scrollY,
								behavior: 'smooth'
							});
						}
					}
				}

				// refresh pickup availability widgets

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
				}

			}

			// update prices (overwrites the framework)

            let global_discount = (100.0 - window.storePromo.sitewidePercent) / 100.0;

			if ( this.priceCompact ) {
				if ( !variant ) {
					if ( ! ( this.productVariants.variantRequired && this.productVariants.noVariantSelectedYet ) ) {
						this.priceCompact.classList.add('hide');
						this.priceCompact.priceOriginal.innerHTML = '';
						this.priceCompact.priceCompare.innerHTML = '';
						this.priceCompact.priceUnit.innerHTML = '';
					}
				} else {
                  if(selling_option == 'recurring') {
                    this.priceCompact.classList.remove('hide');
					this.priceCompact.priceOriginal.innerHTML = this.productVariants._formatMoney(selling_plan.price * global_discount, KROWN.settings.shop_money_format);
					let max_price = Math.max(variant.price, variant.compare_at_price, selling_plan.compare_at_price);
					if ( max_price > selling_plan.price * global_discount ) {
						this.priceCompact.priceCompare.innerHTML = this.productVariants._formatMoney(max_price, KROWN.settings.shop_money_format);
					//if ( selling_plan.compare_at_price > selling_plan.price ) {
						//this.priceCompact.priceCompare.innerHTML = this.productVariants._formatMoney(selling_plan.compare_at_price, KROWN.settings.shop_money_format);
						//this.priceCompact.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(selling_plan.compare_at_price, KROWN.settings.shop_money_format)}</span><span class="product-item__badge">-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%</span>`;
					} else {
						this.priceCompact.priceCompare.innerHTML = '';
					}
					if (global_discount == 1) {
						this.priceCompact.isSale.classList.remove('hide');
					}
                  } else {
                    this.priceCompact.classList.remove('hide');
					this.priceCompact.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price * global_discount, KROWN.settings.shop_money_format);
					if ( variant.compare_at_price > variant.price * global_discount ) {
						this.priceCompact.priceCompare.innerHTML = this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
						//this.priceCompact.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span class="product-item__badge">-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%</span>`;
					} else if ( !variant.compare_at_price && global_discount < 1 ) {
						this.priceCompact.priceCompare.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
					} else {
						this.priceCompact.priceCompare.innerHTML = '';
					}
					if (global_discount == 1) {
						this.priceCompact.isSale.classList.add('hide');
					}
                  }
					

					if ( variant.unit_price_measurement ) {
						this.priceCompact.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceCompact.priceUnit.innerHTML = '';
					}
				}
			}

			if ( this.priceExtended ) {
				if ( !variant ) {
					this.priceExtended.classList.add('hide');
					this.priceExtended.priceOriginal.innerHTML = '';
					this.priceExtended.priceCompare.innerHTML = '';
					this.priceExtended.priceUnit.innerHTML = '';
					this.priceExtended.priceSaving.innerHTML = '';
				} else {
                  if(selling_option == 'recurring') {
                  	this.priceExtended.classList.remove('hide');
					this.priceExtended.priceOriginal.innerHTML = this.productVariants._formatMoney(selling_plan.price * global_discount, KROWN.settings.shop_money_format);
					if ( selling_plan.compare_at_price > selling_plan.price * global_discount ) {
						this.priceExtended.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(selling_plan.compare_at_price, KROWN.settings.shop_money_format)}</span>`;
						this.priceExtended.priceSaving.innerHTML = `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this.productVariants._formatMoney(selling_plan.compare_at_price - selling_plan.price, KROWN.settings.shop_money_format))}</span>`;
					} else {
						this.priceExtended.priceCompare.innerHTML = '';
						this.priceExtended.priceSaving.innerHTML = '';
					}
                  } else {
                    this.priceExtended.classList.remove('hide');
					this.priceExtended.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price * global_discount, KROWN.settings.shop_money_format);
					if ( variant.compare_at_price > variant.price * global_discount ) {
						this.priceExtended.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span>`;
						this.priceExtended.priceSaving.innerHTML = `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this.productVariants._formatMoney(variant.compare_at_price - variant.price, KROWN.settings.shop_money_format))}</span>`;
					} else {
						this.priceExtended.priceCompare.innerHTML = '';
						this.priceExtended.priceSaving.innerHTML = '';
					}
                  }
                  


					if ( variant.unit_price_measurement ) {
						this.priceExtended.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceExtended.priceUnit.innerHTML = '';
					}
				}
			}
			if (this.priceOneTime) {
				if(!variant) {
					this.priceOneTime.classList.add('hide');
					this.priceOneTime.priceOriginal.innerHTML = '';
					this.priceOneTime.priceCompare.innerHTML = '';
				}
				else {
					this.priceOneTime.classList.remove('hide');
					this.priceOneTime.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price * global_discount, KROWN.settings.shop_money_format);
					if (variant.compare_at_price > variant.price * global_discount ) {
						this.priceOneTime.priceCompare.innerHTML = this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
					}
					else {
						this.priceOneTime.priceCompare.innerHTML = '';
					} 
				}
			}

		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break; 
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}